import React, { PropsWithChildren } from 'react';

import Toolbar from '@components/toolbar/Toolbar';

import Cursor from './cursor/Cursor';

interface Props extends PropsWithChildren {
  isMounted: boolean;
  shouldRender: boolean;
}

const NSCWrapper: React.FC<Props> = ({ isMounted, shouldRender, children }) => {
  const mountedStyle = { animation: 'inAnimation 400ms ease-in-out' };
  const unmountedStyle = { animation: 'outAnimation 200ms ease-in-out' };

  return (
    <div className="nsc-wrapper">
      <div
        className="nsc-wrapper__content"
        style={isMounted ? mountedStyle : unmountedStyle}>
        <Cursor />
        {shouldRender && children}
      </div>
      <Toolbar />
    </div>
  );
};

export default NSCWrapper;
